import { Injectable } from '@angular/core';

@Injectable()
export class CurrencyService 
{
    constructor
    (
        
    ) {}

    getCurrency ()
    {
        let param = '$';

        switch (param)
        {
            case '$': return 'USD';
            case '€': return 'EUR';
            default: return 'EUR';
        }
    }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/currency.service.ts